import { createFileRoute } from "@tanstack/react-router";
import { PharmaPage, pharmaHead } from "@/pages/PharmaPage";

export const Route = createFileRoute("/brancher/pharma-life-science")({
  head: () => pharmaHead("da"),
  component: () => <PharmaPage locale="da" />,
});
